import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f8f0e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Caller Phone Number: ")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Caller Name: ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Location: ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" GPS: ")
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Undefined ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { key: 2 }


  import { ServerEventResponse } from "../../types/sse-types";

  import ElapsedTime from './ElapsedTime.vue';
  import EmergencyAddress from './EmergencyAddress.vue';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CallDetails',
  props: {
    callData: { type: Object as () => ServerEventResponse, required: true },
    emergency: { type: Boolean, required: true }
  },
  setup(__props) {

  

  const formatLink = (coordinates: string[]) => {
    const data = coordinates[0].split(',');
    return `https://www.google.com/maps/search/?api=1&query=${data[0]}%2C${data[1]}`
  }

  const formatCoordinates = (coordinates: string[]) => {
    const data = coordinates[0].split(',');
    const [lat, long] = data;
    return `${lat}, ${long}` 
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card text-center mb-2", [__props.emergency ? 'emergency' : undefined]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-header callee-timer", [__props.emergency ? 'emergency-header' : undefined]])
    }, [
      _createElementVNode("div", _hoisted_1, " Call Inbound to: " + _toDisplayString(__props.callData.payload.object.callee.phone_number), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ElapsedTime, {
          date: new Date(__props.callData.event_ts)
        }, null, 8, ["date"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(new Date(__props.callData.event_ts).toLocaleDateString()), 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(new Date(__props.callData.event_ts).toLocaleString('en-US', 
                { hour: 'numeric', minute: 'numeric', hour12: true })) + " ", 1),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("b", null, [
            _createElementVNode("a", {
              href: `tel:${__props.callData.payload.object.caller.extension_number}`
            }, _toDisplayString(__props.callData.payload.object.caller.extension_number), 9, _hoisted_10)
          ]),
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("b", null, _toDisplayString(__props.callData.payload.object.caller.display_name), 1),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(EmergencyAddress, {
            address: __props.callData.payload.object.emergency_address
          }, null, 8, ["address"]),
          _hoisted_16,
          _hoisted_17,
          (__props.callData.payload.object.location.gps)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: formatLink(__props.callData.payload.object.location.gps),
                target: "_blank"
              }, _toDisplayString(formatCoordinates(__props.callData.payload.object.location.gps)), 9, _hoisted_18))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_19
              ], 64)),
          _hoisted_20,
          (__props.callData.payload.object.deliver_to == 'MOBILE_911_CALL')
            ? (_openBlock(), _createElementBlock("b", _hoisted_21, " ATTEMPT ROUTED TO MOBILE CARRIER "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}
}

})